import { Button } from "antd";
import SuccessGreenIcon from "../../assets/icons/SuccessGreenIcon";
import { TransactionsDetails } from "../../types/statements";
import CustomModal from "../ui/CustomModal";

interface ModalComponentProps<DataT = never, TypeT = never> {
  open: boolean;
  handleClose: (val?: any) => void;
  type?: "ADD" | "UPDATE" | "VIEW" | TypeT;
  data?: DataT;
  title?: string;
  buttonText?: string;
}

export default function SuccessModal({
  handleClose,
  type,
  data,
  title,
  buttonText,
  ...rest
}: ModalComponentProps<TransactionsDetails>) {
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={460}
        footer={null}
      >
        <div className="flex justify-center items-center my-5">
          <SuccessGreenIcon />
        </div>

        <div className="text-center text-zinc-700 text-2xl font-medium my-5">
          {title}
        </div>

        <div className="flex justify-center items-center">
          <Button
            className="h-12 px-4 rounded-lg inline-flex justify-center items-center gap-2.5 text-base font-medium bg-[#E5F1FF] text-[#147AFF]
          !border-none !hover:border-none  hover:text-[#147AFF]"
          >
            {buttonText}
          </Button>
        </div>
      </CustomModal>
    </>
  );
}
